import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ToasterService } from 'angular2-toaster';
import axios from 'axios';
import * as moment from 'moment';
import * as urlRegex from 'url-regex';
import { IMyDpOptions } from 'mydatepicker';
import {API_BASE_URL, ENDPOINTS, USER_ROLES} from '../app.config';
import Utils from '../app.utilities';
import { CompanyService } from '../company.service';
import { UserInfoService } from '../shared/user-info.service';
import { TranslateService } from '@ngx-translate/core';

const utilities = new Utils();

@Component({
  selector: 'app-media',
  templateUrl: './media.component.html',
  styleUrls: ['./media.component.css'],
  // Is already provided in ../app.module.ts
  //  but the UserInfoService, in the constructor, needs access to ActivatedRoute.params
  //  https://stackoverflow.com/questions/39977962/angular-2-0-2-activatedroute-is-empty-in-a-service
  providers: [UserInfoService]
})
export class MediaComponent implements OnInit {
  assets: any;
  companyId: string;
  sub: any;
  baseUrl: string;
  momentLib: any;
  downloadAssetUrl: string;
  deleteAssetUrl: string;
  assetsForRemoval: any[];
  fromDate: any;
  toDate: any;
  errorFields: any;
  filesForUpload: any;
  listOfFilesForUpload: any;
  countFilesForUpload: number;
  countChooses: number;
  hideFileChooser: boolean;
  fieldsForTemplateTypeHtmlLink: boolean;
  gettingAssetsInProgress: boolean;
  uploadInProgress: boolean;
  toaster: ToasterService;
  route: ActivatedRoute;
  sanitizer: DomSanitizer;
  assetsTotal: any;
  assetsPerPage: any;
  totalPages: number;
  currentPage: number;
  myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd.mm.yyyy',
  };
  formData: FormData;
  templateType: string;
  subType: string;
  contentType: string;
  fileName: string;
  urlAddress: string;
  companyName: string;
  userRole: string;
  companyService: any;
  templateTypes = {
    image: 'picture',
    slideshow: 'slideshow',
    video: 'video',
    html_video: 'html_video',
    html_link: 'html_link',
    html: 'html_folder',
    metals_exchange_list: 'metal_exchange_rate',
    currency_exchange_list: 'currency_exchange_rate',
    led: 'led_display',
    fixed_html_video: 'fixed_html_video',
  };
  filterTemplateType: any = '';
  filterContentType: any = '';
  filterSubType: any = '';
  getAssetsLastCalledWithDates : boolean;
  unloadedHeavyAssets : any;
  unloadedHeavyAssetsIntervalChecker : any = {};
  businesOwnerName : string;
  businessOwnerIdLocalStorage = localStorage.getItem('businessOwnerId');

  // Messages
  error_file_type: string;
  error_html_folder: string;
  loading_unsuccessful: string;
  mark_materials_for_deletion: string;
  materials_successfully_deleted: string;
  loading_successfully: string;

  constructor(
    route: ActivatedRoute,
    sanitizer: DomSanitizer,
    toaster: ToasterService,
    companyService: CompanyService,
    private userInfoService : UserInfoService,
    private translate: TranslateService
  ) {
    this.route = route;
    this.sanitizer = sanitizer;
    this.baseUrl = API_BASE_URL;
    this.momentLib = moment;
    this.toaster = toaster;
    this.assetsForRemoval = [];
    this.filesForUpload = [];
    this.listOfFilesForUpload = [];
    this.countFilesForUpload = 0;
    this.countChooses = 0;
    this.errorFields = [];
    this.fileName = '';
    this.templateType = 'image';
    this.contentType = 'Info';
    this.subType = 'Novica';
    this.formData = new FormData();
    this.uploadInProgress = false;
    this.gettingAssetsInProgress = false;
    this.currentPage = 1;
    this.companyService = companyService;
  }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.companyId = params.companyId;
      this.downloadAssetUrl = ENDPOINTS.DOWNLOAD_ASSET.replace(
        ':companyId',
        this.companyId,
      );
      this.deleteAssetUrl = ENDPOINTS.DELETE_ASSET.replace(
        ':companyId',
        this.companyId,
      );
      this.companyService.setCompanyId(this.companyId);
      this.getAssets(false);
      this.getUserInfo();
    });
    this.filesForUpload = [];
    this.listOfFilesForUpload = [];

    // Messages translations
    this.translate.stream('SHARED.Messages.error_file_type').subscribe((res: string) => {
      this.error_file_type = res;
    });
    this.translate.stream('SHARED.Messages.error_html_folder').subscribe((res: string) => {
      this.error_html_folder = res;
    });
    this.translate.stream('SHARED.Messages.loading_unsuccessful').subscribe((res: string) => {
      this.loading_unsuccessful = res;
    });
    this.translate.stream('SHARED.Messages.mark_materials_for_deletion').subscribe((res: string) => {
      this.mark_materials_for_deletion = res;
    });
    this.translate.stream('SHARED.Messages.materials_successfully_deleted').subscribe((res: string) => {
      this.materials_successfully_deleted = res;
    });
    this.translate.stream('SHARED.Messages.loading_successfully').subscribe((res: string) => {
      this.loading_successfully = res;
    });
  }

  uploadFiles() {
    if (this.uploadInProgress) {
      return;
    }
    if (this.templateType === 'image' || this.templateType === 'slideshow') {
      if (this.countChooses > 0) {
        for (const fileList of this.listOfFilesForUpload) {
          for (const file of fileList) {
            if (!file.type.includes('image')) {
              return this.toaster.pop('error', this.error_file_type);
            }
          }
        }
      } else {
        for (const file of this.filesForUpload) {
          if (!file.type.includes('image')) {
            return this.toaster.pop('error', this.error_file_type);
          }
        }
      }
    }
    if (this.templateType === 'video') {
      for (const file of this.filesForUpload) {
        if (!file.type.includes('video')) {
          return this.toaster.pop('error', this.error_file_type);
        }
      }
    }
    if (this.templateType === 'html_video' || this.templateType === 'fixed_html_video') {
      for (const file of this.filesForUpload) {
        if (!file.type.includes('video')) {
          return this.toaster.pop('error', this.error_file_type);
        }
      }
    }
    if (this.templateType === 'html') {
      for (const file of this.filesForUpload) {
        if (!file.type.includes('zip')) {
          return this.toaster.pop('error', this.error_file_type);
        }
      }
    }
    const _self = this;
    this.uploadInProgress = true;
    this.formData.append('asset[name]', this.fileName);
    this.formData.append('asset[template_type]', this.templateType);
    this.formData.append('asset[content_type]', this.contentType);
    this.formData.append('asset[subtype]', this.subType);
    if(this.fieldsForTemplateTypeHtmlLink){
      this.formData.append('asset[html_link_url]', this.urlAddress);
    }
    axios
      .post(
        ENDPOINTS.ASSETS.replace(':companyId', this.companyId),
        this.formData,
      )
      .then(
        response => {
          _self.getAssets(false);
          const file = document.getElementById('fileChooser');
          if (!_self.hideFileChooser) {
            file.setAttribute('type', '');
            file.setAttribute('type', 'file');
          }

          _self.fileName = '';
          _self.templateType = 'image';
          _self.contentType = 'Info';
          _self.subType = 'Novica';
          _self.fieldsForTemplateTypeHtmlLink = false;
          _self.urlAddress = '';
          _self.filesForUpload = [];
          _self.listOfFilesForUpload = [];
          _self.errorFields = [];
          _self.uploadInProgress = false;
          _self.hideFileChooser = false;
          _self.formData = new FormData();
          _self.toaster.pop('success', this.loading_successfully);
          this.countFilesForUpload = 0;
          this.countChooses = 0;
        },
        error => {
          _self.uploadInProgress = false;
          if(_self.templateType == "html"){
            // angular2-toaster configuration: https://www.npmjs.com/package/angular2-toaster#getting-started-with-configuration-override
            _self.toaster.pop({
                type: 'error',
                title: this.error_html_folder,
                timeout: 10000
              });
          } else {
            _self.toaster.pop('error', this.loading_unsuccessful);
          }
        },
      );
  }



  getCompanyInfo() {
    // const _self = this;
    // axios
    //   .get(ENDPOINTS.GET_COMPANIES + '/' + _self.companyId)
    //   .then(response => {
    //     _self.companyName = response.data.name;
    //   });
  }

  fileChange(event) {
    const files = event.target.files;
    if (files.length > 0) {
      if (this.templateType === 'slideshow' && this.countChooses > 0) {
        if (this.countChooses === 1) {
          this.listOfFilesForUpload.push(this.filesForUpload);
        }
        this.countChooses = this.countChooses + 1;
        this.listOfFilesForUpload.push(files);
        this.countFilesForUpload = this.countFilesForUpload + files.length;
        const listFiles = [];
        for (const fileList of this.listOfFilesForUpload) {
          for (const file of fileList) {
            listFiles.push(file);
          }
        }
        for (let i = 0; i < listFiles.length; i++) {
          const file = listFiles[i];
          this.formData.append(
            'asset[asset_files_attributes][' + i + '][data]',
            file,
            file.name,
          );
        }
      } else {
        this.countChooses = 1;
        this.filesForUpload = files;
        this.countFilesForUpload = this.filesForUpload.length;
        for (let i = 0; i < this.filesForUpload.length; i++) {
          const file = this.filesForUpload[i];
          this.formData.append(
            'asset[asset_files_attributes][' + i + '][data]',
            file,
            file.name,
          );
        }
      }
    } else {
      this.filesForUpload = [];
    }
  }

  getUserInfo() {
    const _self = this;

    this.userInfoService.getInformations()
    .subscribe( info => {
      _self.userRole         = info.userRole;
      _self.companyName      = info.companyName;
      _self.businesOwnerName = info.businesOwnerName;
    });
  }

  removeAssets(removalStarted) {
    if (!removalStarted && this.assetsForRemoval.length === 0) {
      this.toaster.pop('error', this.mark_materials_for_deletion);
    } else if (removalStarted && this.assetsForRemoval.length === 0) {
      this.toaster.pop('success', this.materials_successfully_deleted);
      if (this.assets.length === 1 && this.currentPage > 0) {
        this.currentPage--;
      }
      this.getAssets(false);
    } else {
      const _self = this;
      axios
        .delete(
          _self.deleteAssetUrl.replace(':assetId', _self.assetsForRemoval[0]),
        )
        .then(response => {
          _self.assetsForRemoval.splice(0, 1);
          _self.removeAssets(true);
        });
    }
  }

  toggleAssetRemoval(assetId) {
    if (this.assetsForRemoval.includes(assetId)) {
      this.assetsForRemoval.splice(this.assetsForRemoval.indexOf(assetId), 1);
    } else {
      this.assetsForRemoval.push(assetId);
    }
  }

  openAsset(url, assetStatus) {
    if (assetStatus && assetStatus === 'completed') {
      window.open(url, '_blank');
    }
  }

  onToDateChanged(event) {
    const _self = this;
    if (_self.fromDate) {
      setTimeout(() => {
        _self.getAssets(true);
      }, 500);
    } else {
      _self.getAssets(false);
    }
  }

  onFromDateChanged(event) {
    const _self = this;
    if (_self.toDate) {
      setTimeout(() => {
        _self.getAssets(true);
      }, 500);
    } else {
      _self.getAssets(false);
    }
  }

  filterSelectChanged() {
    this.currentPage = 1;
    this.getAssets(this.fromDate || this.toDate)
  }

  getUrlWithSelectFilters(url: string): string {
    const _self = this;

    if (this.filterTemplateType !== '') {
      url = url.includes('?') ? `${url}&template_type=${_self.filterTemplateType}` : `${url}?template_type=${_self.filterTemplateType}`
    }

    if (this.filterContentType !== '') {
      url = url.includes('?') ? `${url}&content_type=${_self.filterContentType}` : `${url}?content_type=${_self.filterContentType}`
    }

    if (this.filterSubType !== '') {
      url = url.includes('?') ? `${url}&subtype=${_self.filterSubType}` : `${url}?subtype=${_self.filterSubType}`
    }

    return url;
  }

  generatePages() {
    if (!this.totalPages) {
      return [];
    }
    const arr = [];
    for (let i = 0; i < this.totalPages; i++) {
      arr.push(i + 1);
    }
    return arr;
  }

  loadAssets(page, isDisabled) {
    if (!isDisabled && !this.gettingAssetsInProgress) {
      this.currentPage = page;
      this.getAssets(false);
      this.assetsForRemoval = [];
    }
  }

  getAssets(withDates) {
    const _self = this;
    // store last parameter value to use it in getFreshAssets
    _self.getAssetsLastCalledWithDates = withDates;

    if (_self.gettingAssetsInProgress) {
      return;
    }
    _self.gettingAssetsInProgress = true;
    let url = withDates && _self.fromDate && _self.toDate
      ? ENDPOINTS.ASSETS.replace(':companyId', this.companyId) +
          '?from_date=' +
          _self.fromDate.formatted +
          '&to_date=' +
          _self.toDate.formatted
      : ENDPOINTS.ASSETS.replace(':companyId', this.companyId);
    url = _self.getUrlWithSelectFilters(url)
    axios.get(url).then(
      response => {
        _self.assetsTotal = parseInt(response.headers['total'], 10);
        _self.assetsPerPage = parseInt(response.headers['per-page'], 10);
        _self.totalPages = Math.floor(
          _self.assetsTotal % _self.assetsPerPage,
        ) === 0
          ? _self.assetsTotal / _self.assetsPerPage
          : Math.floor(_self.assetsTotal / _self.assetsPerPage) + 1;
        let urlWithPaging = withDates && _self.fromDate && _self.toDate
          ? ENDPOINTS.ASSETS.replace(':companyId', this.companyId) +
              '?page=' +
              _self.currentPage +
              '&per_page=' +
              _self.assetsPerPage +
              '&from_date=' +
              _self.fromDate.formatted +
              '&to_date=' +
              _self.toDate.formatted
          : ENDPOINTS.ASSETS.replace(':companyId', this.companyId) +
              '?page=' +
              _self.currentPage +
              '&per_page=' +
              _self.assetsPerPage;

        urlWithPaging = _self.getUrlWithSelectFilters(urlWithPaging)

        axios.get(urlWithPaging).then(
          paginationResponse => {
            _self.assets = paginationResponse.data;
            _self.gettingAssetsInProgress = false;
            _self.checkUnloadedHeavyAssets();
          },
          error => {
            _self.gettingAssetsInProgress = false;
          },
        );
      },
      error => {
        _self.gettingAssetsInProgress = false;
      },
    );
  }

  getFreshAssets(withDates) {
    const _self = this;

    // NOTE: is almost exactly the same code as inside getAssets(),
    // JUST without variable check "gettingAssetsInProgress" - current function is called only by:  checkUnloadedHeavyAssets()
    // makes a call on the Server Data for the current page
    let url = withDates && _self.fromDate && _self.toDate
      ? ENDPOINTS.ASSETS.replace(':companyId', this.companyId) +
          '?from_date=' +
          _self.fromDate.formatted +
          '&to_date=' +
          _self.toDate.formatted
      : ENDPOINTS.ASSETS.replace(':companyId', this.companyId);
    url = _self.getUrlWithSelectFilters(url)
    axios.get(url).then(
      response => {
        _self.assetsTotal = parseInt(response.headers['total'], 10);
        _self.assetsPerPage = parseInt(response.headers['per-page'], 10);
        _self.totalPages = Math.floor(
          _self.assetsTotal % _self.assetsPerPage,
        ) === 0
          ? _self.assetsTotal / _self.assetsPerPage
          : Math.floor(_self.assetsTotal / _self.assetsPerPage) + 1;
        let urlWithPaging = withDates && _self.fromDate && _self.toDate
          ? ENDPOINTS.ASSETS.replace(':companyId', this.companyId) +
              '?page=' +
              _self.currentPage +
              '&per_page=' +
              _self.assetsPerPage +
              '&from_date=' +
              _self.fromDate.formatted +
              '&to_date=' +
              _self.toDate.formatted
          : ENDPOINTS.ASSETS.replace(':companyId', this.companyId) +
              '?page=' +
              _self.currentPage +
              '&per_page=' +
              _self.assetsPerPage;

        urlWithPaging = _self.getUrlWithSelectFilters(urlWithPaging)

        axios.get(urlWithPaging).then(
          paginationResponse => {
              _self.afterFreshAssetsReceived(paginationResponse);
          },
          error => {
          },
        );
      },
      error => {
      },
    );
  }

  // after the form submit of a new asset with one of these types: html, html_video, video
  checkUnloadedHeavyAssets() {
    let _self = this;
    function getUnloadedHeavyAssets(){
      return _self.assets.filter( heavyAsset => {
        // if one of these asset types: html, html_video, video is still processing
        // make a request to the server and see if one has been processed completly
        return (heavyAsset.template_type === 'html' || heavyAsset.template_type === 'html_video'
          || heavyAsset.template_type === 'video' || heavyAsset.template_type === 'fixed_html_video') && heavyAsset.status === 'processing';
      });
    }
    let unloadedHeavyAssets = getUnloadedHeavyAssets();

    // if a asset in the current page
    // with template_type == "html"
    // and status == "processing" (hast not been processed by the server at the last assets call)
    if( unloadedHeavyAssets.length ){
      this.unloadedHeavyAssets = unloadedHeavyAssets;
      // if is not already running -  SetInterval monkey patched by Zone.js
      // empty object or a Zone.js interval
      if( 0 == Object.keys(_self.unloadedHeavyAssetsIntervalChecker).length || ("state" in _self.unloadedHeavyAssetsIntervalChecker && _self.unloadedHeavyAssetsIntervalChecker.state == "notScheduled") ) {
          if( "state" in _self.unloadedHeavyAssetsIntervalChecker && _self.unloadedHeavyAssets.state == "notScheduled"){

          }
          _self.unloadedHeavyAssetsIntervalChecker = setInterval( () => {
              // first parameter is to simulate last pagination call on getAssets() line 319
              _self.getFreshAssets(_self.getAssetsLastCalledWithDates);
          // NOTE: it takes around 30 secconds untill the server processes a .zip file with size 637KB - 7/12/2017
          }, 7000);
      }
    }
  }

  afterFreshAssetsReceived(freshAssets){
    let _self = this,
       completelyProcessedHeavyAssets = [];

    this.unloadedHeavyAssets.forEach( unloadedAsset => {
      // check newly received assets who are the same as the unloaded ones
      // store them if they have been completely processed
      completelyProcessedHeavyAssets = freshAssets.data.filter( freshAsset => {
        return freshAsset.id === unloadedAsset.id && freshAsset.status === "completed";
      });
    });

    // when one ore more freshAssets have been completely processed
    if(completelyProcessedHeavyAssets.length){
      this.assets = freshAssets.data;

      // completelyProcessedHeavyAssets have been processed completely at the time of the current request to API
      //   they have NOT been completely processed at the previous request to the API
      // assets from completelyProcessedHeavyAssets who are within this.unloadedHeavyAssets should be removed
      //   because this means that they have been completely processed at this request to API
      let remainedUnloadedAssets = this.unloadedHeavyAssets;
      completelyProcessedHeavyAssets.forEach( completedAsset => {
        remainedUnloadedAssets = this.unloadedHeavyAssets.filter( unloadedAsset => {
          return unloadedAsset.id != completedAsset.id
        });
      });
      this.unloadedHeavyAssets = remainedUnloadedAssets;
    }

    // if no heavy assets have remained unloaded
    if( 0 === this.unloadedHeavyAssets.length){
      clearInterval(this.unloadedHeavyAssetsIntervalChecker);
    }
  }

  isFormValid() {
    this.errorFields = [];
    if (!this.fileName) {
      this.errorFields.push('fileName');
    }
    if (!this.contentType) {
      this.errorFields.push('contentType');
    }
    if (!this.subType) {
      this.errorFields.push('subType');
    }
    if (!this.templateType) {
      this.errorFields.push('templateType');
    }
    // only if the choosen templateType is html_link
    if ( this.fieldsForTemplateTypeHtmlLink && !this.isUrlInputValid() ) {
      this.errorFields.push('urlAddress');
    }
    if (
      // NOTE debugg html_folder might need to be only html
      this.filesForUpload.length === 0 &&
      (this.templateType === 'image' ||
        this.templateType === 'video' ||
        this.templateType === 'html_video' ||
        this.templateType === 'slideshow' ||
        this.templateType === 'html_folder' ||
        this.templateType === 'fixed_html_video')
    ) {
      this.errorFields.push('files');
    }
    return this.errorFields.length === 0;
  }

  isUrlInputValid() {
      let isValid = urlRegex().test(this.urlAddress);
      if(!isValid) {
          this.errorFields.push('urlAddress');
      } else if(this.errorFields.includes('urlAddress')){
          let index = this.errorFields.indexOf('urlAddress');
          this.errorFields.splice(index, 1);
      }
      return isValid;
  }

  addAsset() {
    if (this.isFormValid()) {
      this.uploadFiles();
    }
  }

  updateAsset(asset) {
    const _self = this;
    axios
      .put(
        ENDPOINTS.ASSETS.replace(':companyId', this.companyId) + '/' + asset.id,
        asset,
      )
      .then(
        response => {
        },
        error => {
          _self.uploadInProgress = false;
        },
      );
  }

  setFileChooserType() {
    this.hideFileChooser =
      this.templateType === 'metals_exchange_list' ||
      this.templateType === 'currency_exchange_list' ||
      this.templateType === 'html_link' ||
      this.templateType === 'led';
      // show certain fields only for templateType html_link
      this.fieldsForTemplateTypeHtmlLink = this.templateType === 'html_link';
      this.filesForUpload = [];
      this.countFilesForUpload = 0;
      this.countChooses = 0;
  }
}



// WEBPACK FOOTER //
// /Users/mihagresak/Documents/git-projects/vintegras-angular-new-clean/src/app/media/media.component.ts